/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatconverterpagedescription3Inputs */

const en_formatconverterpagedescription3 = /** @type {(inputs: Formatconverterpagedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload an image. AI rearranges text, logo and people for each format so nothing gets cut off. This takes about a minute.`)
};

const de_formatconverterpagedescription3 = /** @type {(inputs: Formatconverterpagedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade ein Bild hoch. Die KI ordnet Text, Logo und Personen für jedes Format neu an, sodass nichts abgeschnitten wird. Das dauert etwa eine Minute.`)
};

/**
* | output |
* | --- |
* | "Upload an image. AI rearranges text, logo and people for each format so nothing gets cut off. This takes about a minute." |
*
* @param {Formatconverterpagedescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatconverterpagedescription3 = /** @type {((inputs?: Formatconverterpagedescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatconverterpagedescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatconverterpagedescription3(inputs)
	return de_formatconverterpagedescription3(inputs)
});
export { formatconverterpagedescription3 as "formatConverterPageDescription" }